export default __webpack_public_path__ + "static/media/img_baseBunnyCrochetRattle_grey_p.718cda14.jpg";